<template>
	<div class="hello">
		<div class="shell" :style="videoStyle" @click="open_off">
			<SvgIcon v-if='!playFlag' svg-name="play" size="50"></SvgIcon>
		</div>
		<video class="video" :style="videoStyle" id="myvideo" playsinline="true" webkit-playsinline="true" x-webkit-airplay="allow"
		 airplay="allow" x5-video-player-type="h5" x5-video-player-fullscreen="true" x5-video-orientation="portrait" :src="videomp4">
		</video>
		<!-- <div class="goBack" @click="openTuer">
				点击跳转到APP
			</div> -->
		<div class="top animate__animated animate__fadeInDown">
			<img src="../../public/images/logo.png">
			<div class="write">让按摩变得简单</div>
			<a class="goBack" :href="url">打开看看</a>
		</div>
		<div class="right" v-if="showflag">
			<div class="headimg">
				<img :src="TXimg" />
			</div>
			<div class="heart">
				<SvgIcon v-if='!dzFlag' svg-name="heartWhite" size="25"></SvgIcon>
				<SvgIcon v-if='dzFlag' svg-name="heartRed" size="25"></SvgIcon>
			</div>
			<div class="num">{{dzNum}}</div>
			<div class="heart">
				<SvgIcon svg-name="info" size="25"></SvgIcon>
			</div>
			<div class="num">{{plNum}}</div>
			<div class="more">
				<SvgIcon svg-name="lfznmore" size="30"></SvgIcon>
			</div>
			<div class="num" style="margin-top:-0.8rem;">{{zfNum}}</div>
		</div>
		<div class="bottom" v-if="showflag">
			<div class="title">{{title}}</div>
			<div class="center">{{center}}</div>
		</div>
		<div v-if="!showflag" style="width: 100%;position: absolute;top: 30%;left: 0;text-align: center;font-size: 1.5rem;color: white;z-index: 109;">获取失败,请关闭重试!</div>
	</div>
</template>

<script>
	import SvgIcon from '../components/SvgIcon.vue'
	import request from '../common/request.js'
	import axios from 'axios'
	export default {
		name: 'HelloWorld',
		props: {
			msg: String
		},
		components: {
			SvgIcon
		},
		data() {
			return {
				screenWidth: document.body.clientWidth,
				screenHeight: document.body.clientHeight,
				windowWidth: document.documentElement.clientWidth, //实时屏幕宽度
				windowHeight: document.documentElement.clientHeight, //实时屏幕高度
				playFlag: false,
				dzNum: '15w',
				plNum: '5w',
				zfNum: '1w',
				title: '@小机灵鬼儿',
				center: '哈喽你好呀!你这个小机灵鬼儿!',
				TXimg: '',
				dzFlag: true,
				videomp4: '',
				myVideo: '',
				isIos: false,
				isAndroid: false,
				schemeUrl: '',
				downloadUrl: '',
				ID: '',
				url: 'lfwellness://',
				showflag: true


			}
		},
		mounted() {

		},
		created() {
			let that = this;
			that.ID = window.location.href.split("=")[1]
			let data = {
				"out_id": that.ID,
			}
			let requests = request.getQueryData(data || {})
			axios.post('/api_app/v2/bbspublic/share',
				requests).then(function(data) {
				console.log("data", data);
				if (data.data.ResultCode == 200) {
					that.TXimg = data.data.data.image_path
					that.dzNum = data.data.data.digg_count
					that.plNum = data.data.data.comment_count
					that.zfNum = data.data.data.share_count
					that.title = data.data.data.title
					that.center = data.data.data.content_limit
					that.videomp4 = data.data.data.b_to_file[0].path
					that.myVideo = document.getElementById("myvideo");
					let id = data.data.data.bbs_id
					that.url = 'lfwellness://' + id + '//video'
					if (data.data.data.digg_flag == 1) {
						that.dzFlag = true
					} else {
						that.dzFlag = false
					}
				} else {
					that.showflag = false
					// window.alert("获取失败,请重试!");

				}
			}).catch(function(err) {
				console.log('err', err);
			});
		},
		computed: {
			videoStyle() {
				let that = this
				let style = {}
				style.width = that.windowWidth + 'px';
				style.height = that.windowHeight + 'px';
				// style.overflow = 'hidden';
				return style;
			},
		},
		methods: {
			open_off() {
				let that = this
				that.playFlag = !that.playFlag
				if (that.playFlag == true) {
					that.myVideo.play()
				} else {
					that.myVideo.pause()
				}

			},

		}



	}
</script>

<style scoped>
	@import url("../common/animate.min.css");

	.hello {
		max-width: 33.75rem;
		height: 100%;
		position: relative;
		margin: 0 auto;
		background-color: #000000;

	}

	.hello .top {
		width: 100%;
		max-width: 33.75rem;
		height: 4rem;
		background-color: white;
		position: fixed;
		top: 0;
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: center;
		z-index: 110;

	}

	.hello .top img {
		width: 4rem;
		height: 4rem;
		margin-left: 1rem;
	}

	.hello .top .write {
		width: 57%;
		color: #000000;
		font-size: 1rem;
		font-weight: 550;
		text-align: left;
		padding: 0.3rem 0 0 1rem;
	}

	.hello .video {
		width: 100%;
		height: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
		margin: 0 auto;
	}

	.shell {
		max-width: 33.75rem;
		position: absolute;
		top: 0;
		left: 0;
		z-index: 98;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.failed {}

	.hello .right {
		width: 5rem;
		position: absolute;
		top: 50%;
		right: 0;
		display: flex;
		justify-content: space-between;
		flex-direction: column;
		align-items: center;
		z-index: 109;
	}

	.hello .right .headimg {
		width: 2.5rem;
		height: 2.5rem;
		border-radius: 50%;
		background-color: white;
		overflow: hidden;
	}

	.hello .right .headimg img {
		width: 100%;
	}

	.hello .right .heart {
		width: 100%;
		margin: 0 auto;
		margin-top: 1.5rem;
	}

	.hello .right .num {
		font-size: 1rem;
		color: white;
	}

	.more {
		margin-top: 1rem;
	}

	.hello .bottom {
		position: absolute;
		width: 100%;
		height: 4rem;
		bottom: 0;
		z-index: 99;
	}

	.hello .bottom .title {
		color: white;
		font-size: 1.2rem;
		text-align: left;
		margin: 0 0 0 2%;
	}

	.hello .bottom .center {
		color: white;
		font-size: 0.9rem;
		text-align: left;
		margin: 2% 0 0 2%;
	}

	.hello .top .goBack {
		width: 5rem;
		height: 2rem;
		background-color: #04D09C;
		font-size: 0.9rem;
		color: rgb(255, 255, 255);
		text-decoration: none;
		text-align: center;
		line-height: 2rem;
		margin-right: 1rem;
		/* margin-left: 30%; */
	}
</style>
